import VueControlClass from '../vue-control';

const rmheader_settings = VueControlClass.extend({
  name: 'rmheader_settings',
  alt: 'RM Header Settings',
  panelComponent: 'panel-rmheader-settings',
});

export default rmheader_settings;
